import { useControllableValue } from 'ahooks';
import { Slider as AntdSlider } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Slider = props => {
  const {
    dots,
    disabled,
    lockup,
    marks,
    min = 0,
    max = 100,
    tipFormatter,
    step = 1,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-slider");
  const [value, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  return /*#__PURE__*/_jsx(AntdSlider, {
    className: classNames(baseClassName, className, {
      ["".concat(baseClassName, "-disabled")]: !!disabled,
      ["".concat(baseClassName, "-lockup")]: !!lockup
    }),
    style: style,
    value: value,
    onChange: v => {
      onChange(Math.min(max, Math.max(min, v)));
    },
    dots: dots,
    disabled: disabled,
    tooltip: {
      open: lockup,
      formatter: tipFormatter ? v => {
        return tipFormatter(Math.min(max, Math.max(min, v !== null && v !== void 0 ? v : min)));
      } : undefined,
      getPopupContainer: triggerNode => triggerNode
    },
    marks: marks,
    min: min,
    max: max,
    step: step
  });
};
export default Slider;